module.exports = __webpack_public_path__ + "img/toa-data.b601bd32.jpg";